module.exports = __webpack_public_path__ + "img/watage_res_10.a21bbfdc.gif";